module.exports = __webpack_public_path__ + "img/Weapon_225.a5fda48a.png";